/**
 * This home page for the Search app
 */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import headerImage from "../../header.jpeg";

import { selectHomeData, selectHomeStatus, selectHomeError, initializeAsync } from "./homeSlice";

import { Button, Box, Paper, Menu, MenuItem } from "@mui/material";

import Grid from "@mui/material/Unstable_Grid2";
import { useNavigate } from "react-router-dom";

import { skeleton } from "./skeleton";

import GoogleMapSearch from "../../components/GoogleAutoComplete";
import MarketSearch from "../../components/MarketSearch";

/**
 * Home Component
 * @returns
 */
const Home = () => {
    const data = useSelector(selectHomeData);
    const status = useSelector(selectHomeStatus);
    const error = useSelector(selectHomeError);
    const dispatch = useDispatch();
    const { getUserDetails } = useAuth();
    const navigate = useNavigate();

    const [selected, setSelected] = useState();
    const [isChanging, setIsChanging] = useState();
    const [zoom, setZoom] = useState(8);
    const [mapref, setMapRef] = React.useState(null);
    const [coordinates, setCordinaties] = useState({ lat: 43.45, lng: -80.49 });
    const [markerArray, setMarkerArray] = useState("");

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync({ getUserDetails }));
        }
    }, [status, dispatch, getUserDetails]);

    const handleChildValue = (result) => {
        setMarkerArray(result);
    };

    /**
     * Handler for the Select location from the autocomplete.
     * @param {*} result
     */
    const handleSelectedLocation = (market) => {
        navigate(`/listing-search/markets/${market.id}`);
    };

    let body = (
        <>
            {status === "initalLoading" ? (
                skeleton
            ) : (
                <>
                    <Box sx={{ position: "relative", height: "600px" }}>
                        <Box
                            sx={{
                                position: "absolute",
                                top: "0",
                                width: "100%",
                                height: "100%",
                                backgroundColor: "#8EC5FC",
                                backgroundImage: "linear-gradient(62deg, #8EC5FC 0%, #E0C3FC 100%)",
                            }}
                        ></Box>
                        <Box
                            sx={{
                                zIndex: "100",
                                position: "absolute",
                                top: "40%",
                                left: "calc(50% - 238px)",
                            }}
                        >
                            <MarketSearch onSelect={handleSelectedLocation}></MarketSearch>
                        </Box>
                    </Box>
                </>
            )}
        </>
    );

    return getPageContent(body, status, error);
};

export { Home };
